import classNames from 'classnames';
import styles from './styles.module.scss';

export enum VARIANTS {
  CONFETTI_BLUE = 'confettiBlue',
  ORANGE = 'orange',
  WHITE = 'white',
}

export const TransactionRoomWrapper = ({ children, variant, className = '' }) => {
  return (
    <div className={classNames(styles.trxRoomWrapper, styles?.[variant], className)}>
      {children}
    </div>
  );
};
